import React from 'react'

import Generic from './Generic'
import Mermaid from './Mermaid'

const Component = ({
  code,
  language
}) => {
  const config = configFor(language)
  language = language.split(';')[0]
  return (
    language.startsWith('mermaid') ? (
      <Mermaid code={code} config={config} />
    ) : (
      <Generic code={code} language={language} config={config} />
    )
  )
}

const configFor = (language) => {
  const configString = language.split(';')[1] || ''
  return configString.split('|').reduce((c, current )=> {
    const [key, value] = current.split('=')
    c[key] = value
    return c
  }, {})
}

export default Component